import { GatsbyImage } from "gatsby-plugin-image";
import React from 'react';

import Teaser from '../UI/Teaser/Teaser';
import * as styles from './AuthorCover.module.scss';

const AuthorCover = ({ name, avatar }) => {
  return (
    <header className={styles.container}>
      <div className={styles.inner}>
        <div className={styles.body}>
          <Teaser>Author</Teaser>
          <h1 className={styles.heading}>{name}</h1>

          {avatar && (
            <GatsbyImage
              image={avatar?.localFile?.childImageSharp?.gatsbyImageData}
              className={styles.photo} />
          )}
        </div>
      </div>
    </header>
  );
};

export default AuthorCover;
